import lazyAssetsObserver from 'js/lib/lazy_assets';
import SearchResultCards from 'js/searches/search_result_cards';
import apiRequest from './common/api_request';

const { $ } = window;

function bindPagination() {
  let observer;

  function chooseTarget(threshold) {
    // should not work for boclips view all.
    const panels = $('#search-results > .grid .panel-resource:not(.lp-video)');
    const index =
      panels.length <= threshold ? panels.length - 1 : panels.length - threshold;

    return panels[index];
  }

  let target = chooseTarget(16);

  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(target);
        const nextPage = document.querySelector(
          '#search-pagination .next_page:not(.disabled) a'
        );
        if (nextPage) {
          const url = nextPage.href.replace('/search', '/search.json');
          $('#loading-more-results').removeClass('hide');

          apiRequest.get(url, { params: { pagination: true } }).then(({ data }) => {
            $('#search-results > .grid').append(data.results);
            $('#search-pagination').html(data.pagination);
            lazyAssetsObserver.observe();
            SearchResultCards.allowToBeAddedToCollections();

            $('#loading-more-results').addClass('hide');

            if (window.virtualPageView) window.virtualPageView(url);

            target = chooseTarget(16);
            if (target) observer.observe(target);
            window.LP.module('Popovers').init();
          });
        } else {
          observer.unobserve($('#search-pagination')[0]);
        }
      }
    });
  };

  const options = {
    rootMargin: '0px',
    threshold: 0.0
  };

  observer = new IntersectionObserver(callback, options);
  if (target) {
    observer.observe(target);

    const paginationEl = $('#search-pagination')[0];
    // In case the user scrolls too fast to the bottom and passes the "target".
    if (paginationEl) observer.observe($('#search-pagination')[0]);
  }
}

const SearchInfiniteScroll = {
  init() {
    // let's not show the pagination at all while the infinite scroll is enabled
    $('#search-pagination:not(.boclips-pagination)').addClass('hide');
    bindPagination();
  }
};

export default SearchInfiniteScroll;
